// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"223":"d085792e","745":"a7727a13","807":"c509e74b","850":"a7727a13"}[chunkId] + ".chunk.css";
};